<script setup lang="ts">
import Buttons from '@/components/SizeAndButtons/Popup/Buttons.vue'
import Stitches from '@/components/SizeAndButtons/Popup/Stitches.vue'
import StitchesType from '@/components/SizeAndButtons/QtyPopup/StitchesType.vue'
import { useStore } from '@/stores/store'
import { storeToRefs } from 'pinia'

const store = useStore()
const { isButtons, isStitches } = storeToRefs(store)

function unsetStitchesData() {
  store.crossTopSewing = ''
  store.topStitchesType = ''
}
</script>

<template>
  <div class="space-y-2">
    <fieldset class="form-part space-y-2">
      <legend class="field-name buttons field-label">
        {{ $t('Buttons') }}
      </legend>
      <div class="buttons-block-block" :class="{ 'buttons-yes': isButtons === 'buttons_yes' }">
        <div class="buttons-part">
          <div class="form-group">
            <div class="flex gap-4">
              <label class="simple-radio" for="buttons_yes">
                <input
                  id="buttons_yes"
                  name="isButtons"
                  v-model="isButtons"
                  type="radio"
                  class="radio-input"
                  value="buttons_yes"
                />
                <span class="check-text">{{ $t('Yes') }}</span>
              </label>
              <label class="simple-radio" for="buttons_no">
                <input
                  id="buttons_no"
                  name="isButtons"
                  type="radio"
                  class="radio-input"
                  value="buttons_no"
                  v-model="isButtons"
                />

                <span class="check-text">{{ $t('No') }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
    <Buttons v-if="isButtons == 'buttons_yes'" />
    <fieldset class="form-part stitches-part space-y-2">
      <legend class="field-name stitches field-label">
        {{ $t('Stitches') }}
      </legend>
      <div class="stitches-block" :class="{ 'stitches-yes': isStitches === 'stitches_yes' }">
        <div class="flex gap-4">
          <label class="simple-radio" for="stitches_yes">
            <input
              id="stitches_yes"
              name="isStitches"
              v-model="isStitches"
              type="radio"
              class="radio-input"
              value="stitches_yes"
            />

            <span class="check-text">{{ $t('Yes') }}</span>
          </label>
          <label class="simple-radio" for="stitches_no">
            <input
              name="isStitches"
              v-model="isStitches"
              id="stitches_no"
              type="radio"
              class="radio-input"
              value="stitches_no"
              @click="unsetStitchesData"
            />
            <span class="check-text">{{ $t('No') }}</span>
          </label>
        </div>
      </div>
    </fieldset>
    <Stitches v-if="isStitches === 'stitches_yes'" />
    <StitchesType v-if="isStitches === 'stitches_yes'" />
  </div>
</template>

<style scoped></style>
